import {
  BREAK_DOWN_GRAPH,
  BREAK_DOWN_POST,
  BREAK_DOWN_REASONS,
  BREAK_DOWN_SETTING,
} from "../../constants/apis";
import { getUrl, replaceMultiple } from "../../utilities/helpers";
export const fetchBreakDownReason =
  () =>
  (dispatch, getState, { apiReport }) => {
    return apiReport
      .get(BREAK_DOWN_REASONS)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };
export const fetchBreakDowns =
  (uuid, filters) =>
  (dispatch, getState, { apiReport }) => {
    const baseUrlPath = replaceMultiple(BREAK_DOWN_SETTING, {
      "{{uuid}}": uuid,
    });

    const url = getUrl(baseUrlPath, filters);

    return apiReport
      .get(url)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };
export const fetchDayBreakDownReport =
  (uuid, query) =>
  (dispatch, getState, { apiReport }) => {
    const baseUrlPath = replaceMultiple(BREAK_DOWN_POST, {
      "{{uuid}}": uuid,
    });

    const url = getUrl(baseUrlPath, query);

    return apiReport
      .get(url)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const updateBreakDowns =
  (uuid, payload) =>
  (dispatch, getState, { apiReport }) => {
    const baseUrlPath = replaceMultiple(BREAK_DOWN_POST, {
      "{{uuid}}": uuid,
    });
    return apiReport
      .post(baseUrlPath, payload)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

  export const fetchBreakDownGraph = 
  (templateId, query)=>
    (dispatch, getState,{apiReport})=>{
      const baseUrlPath = replaceMultiple(BREAK_DOWN_GRAPH, {"{{templateId}}":templateId});
      const url = getUrl(baseUrlPath, query);
      return apiReport
      .get(url)
      .then((result)=> result)
      .catch((error)=>{
        throw error
      })
    }
  